import * as z from "zod";
import { defineIntegrationSettings } from "../define-settings";

export const extensivSettings = defineIntegrationSettings({
  fields: {
    customerId: z
      .number()
      .int()
      .positive("Customer ID must be a positive number"),
    facilityId: z
      .number()
      .int()
      .positive("Facility ID must be a positive number"),
  },
  secrets: {},
  connectOnly: {
    clientId: z.string().trim().min(1, "Client ID is required"),
    clientSecret: z.string().trim().min(1, "Client secret is required"),
    userLogin: z.string().trim().min(1, "User login is required"),
  },
  computed: {},
});
